export default __webpack_public_path__ + "948f321.png";